var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.59994 12.8001C7.99994 14.4001 5.49994 14.4001 3.89994 12.8001C2.29994 11.2001 2.19994 8.8001 3.79994 7.3001L8.29994 2.8001C9.29994 1.8001 10.8999 1.8001 11.7999 2.8001C12.7999 3.8001 12.7999 5.4001 11.7999 6.3001L8.29994 9.9001C7.89994 10.3001 7.29994 10.3001 6.89994 9.9001C6.49994 9.5001 6.49994 8.9001 6.89994 8.5001L9.69994 5.7001L8.19994 4.3001L5.49994 7.0001C4.29994 8.2001 4.29994 10.1001 5.49994 11.2001C6.69994 12.3001 8.59994 12.4001 9.69994 11.2001L13.2999 7.6001C15.0999 5.8001 15.0999 3.0001 13.2999 1.2001C11.4999 -0.599902 8.69994 -0.599902 6.89994 1.2001L2.39994 5.9001C0.0999361 8.2001 0.199936 11.9001 2.49994 14.2001C3.69994 15.4001 5.19994 16.0001 6.79994 16.0001C8.39994 16.0001 9.89994 15.4001 10.9999 14.2001L15.2999 9.9001L13.8999 8.5001L9.59994 12.8001Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.de6ae838dc9026adfcb5e109ddb0b1e4.svg";
export { ForwardRef as ReactComponent };